const initialUnits = [
  {
    id: 'drone',
    name: 'Mining Drone',
    count: 0,
    cost: 10,
    production: 1,
    costMultiplier: 1.15,
    description: 'Basic mining unit',
  },
  {
    id: 'factory',
    name: 'Drone Factory',
    count: 0,
    cost: 100,
    production: 8,
    costMultiplier: 1.15,
    description: 'Produces drones automatically',
  },
  {
    id: 'refinery',
    name: 'Ore Refinery',
    count: 0,
    cost: 1100,
    production: 47,
    costMultiplier: 1.15,
    description: 'Refines raw ore into credits',
  },
  {
    id: 'mine',
    name: 'Quantum Mine',
    count: 0,
    cost: 12000,
    production: 260,
    costMultiplier: 1.15,
    description: 'Extracts ore from asteroids',
  },
  {
    id: 'station',
    name: 'Space Station',
    count: 0,
    cost: 130000,
    production: 1400,
    costMultiplier: 1.15,
    description: 'Orbital production facility',
  },
  {
    id: 'nexus',
    name: 'Nexus Core',
    count: 0,
    cost: 1400000,
    production: 7800,
    costMultiplier: 1.15,
    description: 'Advanced AI-driven production',
  },
  {
    id: 'portal',
    name: 'Warp Portal',
    count: 0,
    cost: 20000000,
    production: 44000,
    costMultiplier: 1.15,
    description: 'Interdimensional resource gateway',
  },
  {
    id: 'colony',
    name: 'Planet Colony',
    count: 0,
    cost: 330000000,
    production: 260000,
    costMultiplier: 1.15,
    description: 'Self-sustaining planetary settlement',
  },
  {
    id: 'empire',
    name: 'Galactic Empire',
    count: 0,
    cost: 5100000000,
    production: 1600000,
    costMultiplier: 1.15,
    description: 'Vast interstellar civilization',
  },
];

export default initialUnits;

